(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('EdicaoDemarcacaoCtrl', EdicaoDemarcacaoCtrl);

  EdicaoDemarcacaoCtrl.$inject = [
    '$scope',
    'LoadingService',
    'AtividadesService',
    'ItensService',
    'RelacaoCamposService',
    'DrawPolygonsService',
    'PessoasService',
    '$q',
    'MessagesService',
    'LeafletService',
    'EmpreendimentosService',
    'GlebasService',
    'DrawPolygonsObjectService',
    'CommonHTTPService',
    'MaquinasService',
    'ColorService',
    'CalculationService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function EdicaoDemarcacaoCtrl($scope, LoadingService, AtividadesService,
    ItensService, RelacaoCamposService, DrawPolygonsService,
    PessoasService, $q, MessagesService,
    LeafletService, EmpreendimentosService, GlebasService,
    DrawPolygonsObjectService, CommonHTTPService, MaquinasService, ColorService) {
    const vm = this;
    /**@type L.LayerGroup */
    let drawnItems;
    /**@type L.Control */
    let mapDrawingControl;

    //////////////////////////////////////////
    // Controller data
    vm.glebas = $scope.$root.currentPropriedade.glebas || [];
    vm.atividades = [];
    vm.cultivares = [];
    vm.relacaoCampos = [];
    vm.tipos = [];
    vm.operadores = [];
    vm.empreendimentos = [];
    vm.maquinas = [];
    vm.drawPolygon = {
      polygons: [],
      areaTotal: 0,
      propriedade: $scope.$root.currentPropriedade,
      safra: _.find($scope.$root.safras, { current: true })
    };
    vm.loadingDelete = false;
    vm.loadingSave = false;
    vm.disableSaving = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.goToHistory = GoToHistory;
    vm.changeAtividade = ChangeAtividade;
    vm.recalculateAreas = RecalculateAreas;
    vm.changeFile = ChangeFile;
    vm.removePolygon = RemovePolygon;
    vm.centerPolygon = CenterPolygon;
    vm.delete = Delete;
    vm.save = Save;
    vm.loadMaquinas = loadMaquinas;
    vm.reloadCamposProducao = reloadCamposProducao;

    //////////////////////////////////////////
    // Function declarations

    function GoToHistory() {
      ResetMap();
      $scope.$emit('activateSidebar', 'historyDrawPolygons');
    }

    function ResetMap() {
      if (mapDrawingControl) {
        mapDrawingControl.remove();
      }
      drawnItems.remove();
    }

    function ChangeAtividade(atividade) {
      LoadingService.showLoading();
      const promises = [ReloadCultivares(atividade)];

      if (vm.drawPolygon.tipo === 'empreendimento') {
        promises.push(ReloadEmpreendimentos(atividade));
      }

      $q.all(promises).finally(LoadingService.hideLoading);
    }

    function ReloadCultivares(atividade) {
      if (atividade && atividade.id) {
        return ItensService.listCultivares({
          atividade: atividade.id
        }).then((result) => vm.cultivares = result.data)
          .catch((error) => {
            MessagesService.alert('Falha ao carregar cultivares');
            console.error('Falha ao carregar cultivares', error);
          });
      }
      return $q((resolve) => {
        vm.cultivares = [];
        resolve();
      });
    }

    function ReloadEmpreendimentos(atividade) {
      if (atividade && atividade.id) {
        return EmpreendimentosService.list({
          safra: vm.drawPolygon.safra.id,
          atividade: atividade.id,
          gleba: vm.drawPolygon.gleba
        }).then((result) => vm.empreendimentos = result.data)
          .catch((error) => {
            MessagesService.alert('Falha ao carregar empreendimentos');
            console.error('Falha ao carregar empreendimentos', error);
          });
      }
      return $q((resolve) => {
        vm.empreendimentos = [];
        resolve();
      });
    }

    function loadMaquinas() {
      if (vm.drawPolygon.tipo === 'uso_maquina' && !vm.maquinas.length) {
        LoadingService.showLoading();
        return MaquinasService.list({ simple: true })
          .then(({ data }) => vm.maquinas = data)
          .catch((error) => {
            MessagesService.alert('Falha ao carregar máquinas');
            console.error('Falha ao carregar máquinas', error);
          })
          .finally(LoadingService.hideLoading);
      }
      vm.drawPolygon.maquina = null;
    }

    function CreateDrawingControl() {
      mapDrawingControl = new L.Control.Draw({
        edit: {
          featureGroup: drawnItems,
          poly: {
            allowIntersection: false
          }
        },
        draw: {
          polyline: vm.drawPolygon.tipo === 'plantio_operador',
          polygon: {
            allowIntersection: false,
            showArea: true
          },
          marker: false,
          circlemarker: false,
          circle: false
        }
      });

      return mapDrawingControl;
    }

    // eslint-disable-next-line max-lines-per-function
    function AddDrawingControls() {
      /** @type L.Map */
      const map = LeafletService.getMap('propriedade-map');
      drawnItems.addTo(map);

      map.addControl(CreateDrawingControl());

      map.on(L.Draw.Event.CREATED, (event) => {
        vm.disableSaving = false;
        const layer = event.layer;
        drawnItems.addLayer(layer);
        layer.id = drawnItems.getLayerId(layer);

        if (event.layerType === 'polyline') {
          AddPolyline(layer);
        } else {
          AddPolygon(layer);
        }
      });

      map.on(L.Draw.Event.DELETESTART, () => {
        vm.disableSaving = true;
        $scope.$apply();
      });
      map.on(L.Draw.Event.DELETESTOP, () => {
        vm.disableSaving = false;
        $scope.$apply();
      });
      map.on(L.Draw.Event.DELETED, (event) => {
        const layers = event.layers.getLayers();

        layers.forEach((layer) => {
          const saved = _.findIndex(vm.drawPolygon.polygons, { id: layer.id });

          if (saved > -1) {
            vm.drawPolygon.polygons.splice(saved, 1);
          }
        });

        CalculateTotalArea();
      });

      map.on(L.Draw.Event.EDITSTART, () => {
        vm.disableSaving = true;
        $scope.$apply();
      });
      map.on(L.Draw.Event.EDITSTOP, () => {
        vm.disableSaving = false;
        $scope.$apply();
      });
      map.on(L.Draw.Event.EDITED, (event) => {
        const layers = event.layers.getLayers();

        layers.forEach((layer) => {
          const index = _.findIndex(vm.drawPolygon.polygons, { id: layer.id });
          if (index > -1) {
            const saved = vm.drawPolygon.polygons.splice(index, 1)[0];
            if ((saved.layer || saved.layerType) === 'polyline') {
              AddPolyline(layer);
            } else {
              AddPolygon(layer);
            }
          }
        });
      });
    }

    function AddPolyline(layer, forceApply = true) {
      const latLngs = layer.getLatLngs();
      const polygon = {
        pontos: latLngs.map((latLng) => ({ latitude: latLng.lat, longitude: latLng.lng })),
        area: AreaPlantio(latLngs),
        layer: 'polyline',
        id: layer.id
      };
      RegisterPolygon(polygon, forceApply);
    }

    function AddPolygon(layer, forceApply = true) {
      const latLngs = layer.getLatLngs()[0];
      const polygon = {
        pontos: latLngs.map((latLng) => ({ latitude: latLng.lat, longitude: latLng.lng })),
        area: L.GeometryUtil.geodesicArea(latLngs),
        layer: 'polygon',
        id: layer.id
      };
      RegisterPolygon(polygon, forceApply);
    }

    function RegisterPolygon(polygon, forceApply = true) {
      vm.drawPolygon.polygons.push(polygon);
      CalculateTotalArea();
      if (forceApply) {
        $scope.$apply();
      }
    }

    /*
      Verificado que a distância calculada no aplicativo fica diferente da calculada pela api,
      então ao calcular a área na web pela larguraPlantio * distância fica diferente do aplicativo.
      Foi alterado para não calcular a área quando for uma demarcação de uso de máquina,
      para manter a área igual a do aplicativo e foi criada uma tarefa para revisar
      comportamento de áreas demarcadas de uso de máquina ao criar/editar registros na WEB.
    */
    function CalculateTotalArea() {
      if (vm.drawPolygon.tipo === 'uso_maquina') {
        return;
      }
      vm.drawPolygon.areaTotal = (vm.drawPolygon.polygons.reduce(function(sum, polygon) {
        return sum + Math.max(0, polygon.area);
      }, 0));
    }

    function AreaPlantio(latLngs) {
      const distance = latLngs.reduce((total, latLng, index) => {
        if (index > 0) {
          return total + latLng.distanceTo(latLngs[index - 1]);
        }
        return total;
      }, 0);
      return distance * (vm.drawPolygon.larguraPlantio || 0);
    }

    function RecalculateAreas() {
      vm.drawPolygon.polygons = vm.drawPolygon.polygons.map((polygon) => {
        if (polygon.layer === 'polyline') {
          polygon.area = AreaPlantio(polygon.pontos);
        }
        return polygon;
      });
      CalculateTotalArea();
    }

    function ChangeFile(kmlFile) {
      if (kmlFile && kmlFile.name.match(/(kml|gpx)/)) {
        // LoadingService.showLoading();

        const fileReader = new FileReader();
        fileReader.onload = (fileData) => {
          const resultFileData = fileData.target.result;
          GlebasService.getCoordinatesFromKmlFile(resultFileData).then((data) => {
            const transformPoints = (points) => (points || []).map((point) => ({
              latitude: point[1],
              longitude: point[0]
            }));

            const polygons = DrawPolygonsObjectService.createLeafletPolygons(data.data.map((pontos) => ({
              area: null,
              pontos: transformPoints(pontos)
            })));

            polygons.forEach((polygon) => {
              drawnItems.addLayer(polygon);
              polygon.id = drawnItems.getLayerId(polygon);
              AddPolygon(polygon, false);
            });
          });
        };

        fileReader.readAsText(kmlFile);
      } else {
        MessagesService.alert('Arquivo inválido');
      }
    }

    function RemovePolygon(index) {
      const polygon = vm.drawPolygon.polygons[index];
      vm.drawPolygon.polygons.splice(index, 1);

      drawnItems.removeLayer(drawnItems.getLayer(polygon.id));

      CalculateTotalArea();
    }

    function CenterPolygon(polygon) {
      const latLngs = polygon.pontos.map((latLng) => L.latLng([latLng.latitude, latLng.longitude]));
      /**@type L.Map */
      const map = LeafletService.getMap('propriedade-map');

      map.fitBounds(L.latLngBounds(latLngs), {
        animate: true
      });
    }

    function Delete() {
      if (vm.drawPolygon.id) {
        MessagesService.confirm('Deseja excluir a área demarcada?').then(() => {
          vm.loadingDelete = true;
          return DrawPolygonsService.delete(vm.drawPolygon.id);
        })
          .then(() => {
            MessagesService.alert('Registro excluído com sucesso!');
            GoToHistory();
          })
          .catch(() => MessagesService.alert('Falha ao excluir o registro.'))
          .finally(() => vm.loadingDelete = false);
      }
    }

    function Save(form) {
      if (form.$invalid) {
        return;
      }

      if (!((vm.drawPolygon || {}).polygons || []).length) {
        MessagesService.alert('Demarque uma área no mapa');
        return;
      }

      vm.loadingSave = true;
      DrawPolygonsService.save(vm.drawPolygon).then(() => {
        MessagesService.alert('Área Demarcada salva com sucesso!');
        $scope.$emit('loadDefaultPolygons');
        GoToHistory();
      })
        .catch((error) => {
          if (CommonHTTPService.isBadRequest(error.status) && (error.data || []).glebas) {
            MessagesService.alert(error.data.glebas.join('. '));
          } else {
            MessagesService.alert('Não foi possível salvar a área demarcada! Tente novamente!');
          }

          console.error('Falha ao gravar área demarcada', error);
        })
        .finally(() => vm.loadingSave = false);
    }

    function reloadCamposProducao() {
      LoadingService.showLoading();
      vm.drawPolygon.relacaoCampo = null;
      RelacaoCamposService.list($scope.demarcacao.drawPolygon)
        .then((relacaoCampos) => vm.relacaoCampos = relacaoCampos.data)
        .catch((error) => {
          MessagesService.alert('Não foi possível obter os dados de relações de campos!');
          console.error(error);
        })
        .finally(LoadingService.hideLoading);
    }

    function getTipos(tipos) {
      if (($scope.data || {}).id) {
        return tipos;
      }

      return tipos.filter((item) => item.id !== 'uso_maquina');
    }

    //////////////////////////////////////////
    // Controller logic

    // eslint-disable-next-line max-lines-per-function
    $scope.$root.initialize.then(() => {
      LoadingService.showLoading();

      const promises = [
        AtividadesService.list(),
        ItensService.listCultivares(),
        RelacaoCamposService.list(vm.drawPolygon),
        DrawPolygonsService.tipos(),
        MaquinasService.list({ simple: true }),
        PessoasService.listMaoDeObra()
      ];

      // eslint-disable-next-line max-lines-per-function, complexity
      $q.all(promises).then(([atividades, itens, relacaoCampos, tipos, maquinas, operadores]) => {
        vm.atividades = atividades.data;
        vm.itens = itens.data;
        vm.relacaoCampos = relacaoCampos.data;
        vm.tipos = getTipos(tipos.data);
        vm.maquinas = maquinas.data;
        vm.operadores = operadores.data;

        vm.cores = ColorService.get();

        drawnItems = L.featureGroup();
        AddDrawingControls();

        if (($scope.data || {}).id) {
          vm.drawPolygon = $scope.data.allData;

          if (vm.drawPolygon.relacaoCampo) {
            vm.drawPolygon.relacaoCampo = _.find(vm.relacaoCampos, { id: vm.drawPolygon.relacaoCampo.id });
          }
          if (vm.drawPolygon.tipo) {
            vm.drawPolygon.tipo = vm.drawPolygon.tipo.id;
          }
          if (vm.drawPolygon.operador) {
            vm.drawPolygon.operador = vm.drawPolygon.operador.id;
          }
          if (vm.drawPolygon.maquina_id) {
            vm.drawPolygon.maquina = vm.maquinas.find((maquina) => maquina.id === vm.drawPolygon.maquina_id);
          }
          if (vm.drawPolygon.empreendimento) {
            vm.drawPolygon.empreendimento = vm.drawPolygon.empreendimento.id;
          }
          if (vm.drawPolygon.atividade) {
            vm.changeAtividade(vm.drawPolygon.atividade);
          }

          const polygons = vm.drawPolygon.polygons;
          vm.drawPolygon.polygons = [];
          polygons.forEach((polygon) => {
            if (polygon.layer === 'polyline') {
              const newPolyline = L.polyline(polygon.getLatLngs());
              newPolyline.area = polygon.area;
              newPolyline.layerType = polygon.layer;
              newPolyline.id = drawnItems.getLayerId(newPolyline);
              drawnItems.addLayer(newPolyline);
              AddPolyline(newPolyline, false);
            } else {
              const newPolygon = L.polygon(polygon.getLatLngs());
              newPolygon.area = polygon.area;
              newPolygon.layerType = polygon.layer;
              newPolygon.id = drawnItems.getLayerId(newPolygon);
              drawnItems.addLayer(newPolygon);
              AddPolygon(newPolygon, false);
            }
          });
        }
      })
        .catch((error) => {
          MessagesService.alert('Não foi possível buscar informações de Culturas e Cultivares.');
          console.error(error);
        })
        .finally(LoadingService.hideLoading);
    });

    $scope.$watch('demarcacao.drawPolygon.tipo', () => {
      if (mapDrawingControl) {
        /** @type L.Map */
        const map = LeafletService.getMap('propriedade-map');

        map.removeControl(mapDrawingControl);
        map.addControl(CreateDrawingControl());
      }
    });

    $scope.$on('$destroy', ResetMap);
  }
}());
